// extracted by css-extract-rspack-plugin
export default {"container":"oAxvkb1yWMYFC7SF","logo":"ivBrI2wrpYZosSoZ"};